import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import ProgramsPreview from "./components/ProgramsPreview";
import CommunityHighlights from "./components/CommunityHighlights";
import TestimonialsSection from "./components/TestimonialsSection";
import CTASection from "./components/CTASection";

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <ProgramsPreview />
        <CommunityHighlights />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
